import { render, staticRenderFns } from "./ChatContextMenu.vue?vue&type=template&id=3018790c"
import script from "./ChatContextMenu.vue?vue&type=script&lang=js"
export * from "./ChatContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ChatContextMenu.vue?vue&type=style&index=0&id=3018790c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports